import { gql, useQuery } from '@apollo/client';
import {
  GetTagsQuery,
  GetTagsQueryVariables,
} from '../../__generated__/queries-web';

const GET_TAGS = gql`
  query GetTags(
    $where: TagFilterInput
    $orderBy: [TagOrderingInput!]
    $first: UnsignedInt!
    $skip: UnsignedInt
  ) {
    tags(first: $first, skip: $skip, where: $where, orderBy: $orderBy) {
      id
      title
      slug
      type
      lang
      brandedContents(first: 100) {
        id
        brandKey
        isActive
        body
        media
      }
      articleUsages {
        brandKey
        total
      }
      articleCount
    }
  }
`;

export const useGetTags = (variables: GetTagsQueryVariables, skip?: boolean) =>
  useQuery<GetTagsQuery, GetTagsQueryVariables>(GET_TAGS, {
    variables,
    notifyOnNetworkStatusChange: true,
    skip,
  });
